import script from "./PlatformFilterOption.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformFilterOption.vue?vue&type=script&setup=true&lang=js"

import "./PlatformFilterOption.vue?vue&type=style&index=0&id=77865362&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77865362"]])

export default __exports__